<audit-header></audit-header>
<div class= "col-md-4"> <a (click)="gotoAuditPage()">Back</a></div>

<!-- <span>Waiting for API integration</span> -->
<div class="col-md-12 viewPadding">
<p class="viewWordBreak" *ngIf="!type">{{viewJson.request}}</p>
<p class="viewWordBreak" *ngIf="type">{{viewJson.response}}</p>
</div>
